import { color } from "./constants";

const primaryBackground = {
    /* backgroundColor: color.primary */
    backgroundColor:"var(--ksrtcThColor1)"
}

const primaryBorder = {
    /* borderColor: color.activeInput */
    borderColor: "var(--ksrtcThColor1)"
}

const primaryColor = {
    /* color: color.activeInput */
    color:"var(--ksrtcThColor1)"
}

const secondaryBackground = {
    /* backgroundColor: color.secondary */
    backgroundColor:"var(--ksrtcThColor2)"

}

const secondaryBorder = {
    borderColor: color.secondary
}

const secondaryColor = {
    color: color.secondary
}

export const baseCss = { primaryBackground, primaryBorder, secondaryBackground, secondaryBorder, primaryColor, secondaryColor, }